import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { KPI } from "@/components/Primitives";

const money = (v) => (v == null ? "—" : `$${Number(v).toLocaleString()}`);
const pct = (v) => (v == null ? "—" : `${v}%`);
const num = (v) => (v == null ? "—" : v);

export default function MSPBI() {
  const [d, setD] = useState(null);
  const [err, setErr] = useState(null);
  useEffect(() => {
    api.get("/dashboard/msp-bi").then((r) => setD(r.data || {})).catch(() => setErr("Failed to load MSP BI"));
  }, []);
  if (err) return <div className="text-sm text-red-400">{err}</div>;
  if (!d) return <div className="text-zinc-500 text-sm">Loading…</div>;
  return (
    <div className="space-y-6">
      <div>
        <div className="text-[10px] uppercase tracking-[0.18em] text-zinc-500 font-mono">MSP Business Intelligence</div>
        <h1 className="font-display text-3xl font-semibold tracking-tight mt-1">Profitability &amp; Productivity</h1>
        {d.demo === false && (
          <p className="text-xs text-zinc-500 mt-1">Financial metrics are shown once billing data is connected (demo values hidden in production).</p>
        )}
      </div>
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
        <KPI label="Revenue MTD" value={money(d.revenue_mtd_usd)} tone="good" testid="bi-rev"/>
        <KPI label="Labor Cost MTD" value={money(d.labor_cost_mtd_usd)} testid="bi-labor"/>
        <KPI label="Avg Ticket Cost" value={d.ticket_cost_avg_usd == null ? "—" : `$${d.ticket_cost_avg_usd}`} testid="bi-tkt"/>
        <KPI label="Contract Profit" value={pct(d.contract_profitability_pct)} tone="good" testid="bi-profit"/>
        <KPI label="Tech Productivity" value={pct(d.technician_productivity_pct)} tone="good" testid="bi-prod"/>
        <KPI label="Escalation Rate" value={pct(d.escalation_rate_pct)} tone="warn" testid="bi-esc"/>
        <KPI label="Renewal Probability" value={pct(d.renewal_probability_pct)} tone="good" testid="bi-renew"/>
        <KPI label="Growth QoQ" value={d.growth_qoq_pct == null ? "—" : `+${d.growth_qoq_pct}%`} tone="good" testid="bi-growth"/>
        <KPI label="Avg Resolution" value={d.avg_resolution_hours == null ? "—" : `${d.avg_resolution_hours}h`} testid="bi-res"/>
        <KPI label="Close Rate" value={pct(d.ticket_close_rate_pct)} tone="good" testid="bi-close"/>
        <KPI label="Customer Risk" value={num(d.customer_risk_avg)} tone="warn" testid="bi-risk"/>
      </div>
    </div>
  );
}
